import React, { useRef, useState } from 'react';
import { bool, object } from 'prop-types';
import BasicScroll from './BasicScroll';
import { Image } from '../index';

function BasicScrollImage(props) {
  const { imgProps, scrollProps, isBasicScrollEnabled } = props;
  const [isLoaded, setLoaded] = useState(false);
  const imgRef = useRef();

  return (
    <>
      <Image {...imgProps} innerRef={imgRef} onLoad={() => setLoaded(true)} />
      {isLoaded && isBasicScrollEnabled && <BasicScroll reference={imgRef} {...scrollProps} />}
    </>
  );
}

BasicScrollImage.propTypes = {
  imgProps: object,
  scrollProps: object,
  isBasicScrollEnabled: bool,
};

BasicScrollImage.defaultProps = {
  isBasicScrollEnabled: true,
};

export default BasicScrollImage;
